import { Locale } from '@/interfaces/locale.interface';
import { LocaleState } from '@/interfaces/states/locale-state.interface';
import { LocaleActions } from './actions.enum';

export default {
  [LocaleActions.FETCH](state: LocaleState, items: Locale[]): void {
    state.items = items;
    state.error = { code: null, msg: null };
  },

  [LocaleActions.SET_CURRENT](state: LocaleState, currentId: string): void {
    state.currentId = currentId;
  },

  [LocaleActions.SET_ERROR](state: LocaleState, error: Error & { response: Response }): void {
    state.error = {
      code: error?.response?.status.toString() ?? 0,
      msg: error.response?.statusText ?? error.message,
    };
    console.error(error);
  },
};
